export default __webpack_public_path__ + "static/logo0-132f3c0291cc71ad19aeb149d6e66c13.png";